import copyFromPreviousFields from '../actions/copyFromPreviousFields.js'

export default [copyFromPreviousFields]



// WEBPACK FOOTER //
// ./src/modules/user/chains/copyFromPreviousFields.js